import { MdForum } from 'react-icons/md';
import styled from 'styled-components';

export const Container = styled.header`
  width: 100%;
  background: #004e9a;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1220px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    width: 100%;
    max-width: 1140px;
    margin: 0 40px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const LogoImg = styled.img`
  width: 264px;
  height: auto;
`;

export const Navigation = styled.nav`
  align-items: center;
  color: #ffffff;

  a {
    text-decoration: none;
    color: #ffffff;
    display: flex;
    align-items: center;

    &:hover {
      color: #bbb;
    }
  }

  > span {
    display: inline-block;
    margin: 0 8px;
  }
`;

export const ChatLink = styled.div`
  margin: 0 24px;

  a {
    flex-direction: column;
  }
`;

export const ChatIcon = styled(MdForum)`
  width: 32px;
  height: 32px;
`;
